(function() {
'use strict';

angular
    .module('TR')
    .controller('RootController', RootController);

function RootController($rootScope,
        $scope,
        $location,
        $route,
        $interval,
        bootstrapper,
        publicityService,
        locationService,
        imageService,
        modalService,
        currentDestination,
        agentModeService,
        broker,
        globalisationService,
        analytics) {
    const rc = this;
    let sidebarMenuOpen = false;

    bootstrapper.init();

    $scope.$on('$routeChangeStart', function(scope, next) {
        rc.hideDistractionLinks = !!next.hideDistractionLinks;
        rc.hideTravelAgentLinks = !!next.hideTravelAgentLinks;
        rc.hideSiteFooter = !!next.hideSiteFooter;
        rc.hideFooterToolbar = !!next.hideFooterToolbar;
        rc.inTransactionalFlow = !!next.inTransactionalFlow;
        rc.bodyUncontained = !!next.bodyUncontained;
        rc.minimalHeader = false;
        rc.closeModal();
        rc.hideSiteMailingSignUp();
        rc.showSfChat = !!next.pathParams.tripId;
    });

    broker.subscribe('RootController', 'hideFooter', () => rc.hideSiteFooter = true);
    broker.subscribe('RootController', 'stripHeader', () => rc.minimalHeader = true);

    rc.showPopup = false;
    rc.popupUrl = '';
    rc.impersonatedUserName = false;
    rc.preventPopupClose = true;
    rc.hideHeaderBar = false;
    rc.modalParams = null;
    rc.agentModeEnabled = TRPCONFIG.Domain.isAgentMode;
    rc.DomainHostName = TRPCONFIG.Domain.HostName;
    rc.hideFooterToolBar = TRPCONFIG.Domain2.FooterToolBarABTest;

    $scope.$on('$routeChangeSuccess', function() {
        const regEx = /.*\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[0-9a-fA-F]{0,1}[/]*?/;
        let abtesttUrl = ($location.$$path.match(regEx) || $location.$$path.match(/attractions/));
        const abtesttUrlMatched = abtesttUrl && abtesttUrl.input;
        if (abtesttUrlMatched) {
            rc.hideMinimalHeader = window.TRPCONFIG.Domain2.HideMinimalHeader;
        } else {
            rc.hideMinimalHeader = false;
        }

        // this is needed to poll for when the googletag api is ready and then we force a refresh
        let googletagPoll;
        if ((TRPCONFIG.Domain2.Platform195EnabledPages.includes('home') ||
            TRPCONFIG.Domain2.Platform195MobileEnabledPages.includes('home')) &&
            window.googletag &&
            $location.path() === '/'
        ) {
            googletagPoll = $interval(() => {
                if (window.googletag && window.googletag.apiReady) {
                    const slots = document.querySelectorAll('.platform-195-slot');
                    let refreshSlots = 0;
                    slots.forEach(({ innerHTML }) => {
                        if (/googletag\.cmd\.push/.test(innerHTML) && (!/google_ads_iframe/.test(innerHTML))) {
                            refreshSlots++;
                        }
                    });
                    if (refreshSlots > 0) {
                        window.googletag.pubads().refresh();
                    }
                    $interval.cancel(googletagPoll);
                }
            }, 10);
        }
    });

    if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.ShowAgentOfficeSelector) {
        agentModeService.getAgentInformation().then(function(data) {
            if (data) {
                const officeLocations = data.OfficeLocations;
                if (officeLocations && officeLocations.length > 0) {
                    rc.enableOfficeChange = officeLocations.length > 1;
                    officeLocations.forEach(loc => {
                        if (loc.Id === data.CurrentOfficeLocation) {
                            rc.selectedOfficeLocation = loc.Name;
                        }
                    });
                }
                const permittedDomains = data.PermittedDomains;
                let permittedRegions;
                if (permittedDomains) {
                    globalisationService.getAllDomains().then(allDomains => {
                        const currentDomain = allDomains.filter(d => d.Id === TRPCONFIG.Domain.DomainId)[0];
                        const parentDomainId = currentDomain.ParentId ? currentDomain.ParentId : TRPCONFIG.Domain.DomainId;
                        const parentSubDomains = allDomains.filter(d => d.ParentId === parentDomainId);
                        if (permittedDomains.length === 0) {
                            permittedRegions = parentSubDomains;
                        } else {
                            permittedRegions = parentSubDomains.filter(d => permittedDomains.indexOf(d.Id) !== -1);
                        }
                        rc.enableDomainChange = permittedRegions.length > 1;
                    });
                }
            }
        });
    }

    rc.queryString = () => {
        return location.search.replace('?', '');
    };

    rc.filmCampaignTrack = (event, channel) => {
        const Page = $location.path().match('[^/]+$')[0];
        const data = { Page };
        if (channel) {
            data.Channel = channel;
        }
        analytics.track('mixpanel', event, data);
    };

    modalService.onLaunch(function(val, preventClose, hideHeaderBar) {
        rc.modal(val, preventClose, hideHeaderBar);
    });

    modalService.onClose(function() {
        rc.closeModal();
    });

    rc.modal = function(path, preventClose, hideHeaderBar, modalParams) {
        rc.preventPopupClose = preventClose;
        rc.popupUrl = path;
        rc.showPopup = true;
        rc.hideHeaderBar = hideHeaderBar;
        rc.modalParams = modalParams;
    };

    rc.enableHotelSearchResultsPageDesignChangeABTest = function() {
        return window.TRPCONFIG.Domain2.EnableHotelSearchResultsPageDesignChange;
    };

    rc.closeModal = function() {
        rc.popupUrl = '';
        rc.showPopup = false;
    };

    if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
        publicityService.getStats({
            StatisticTypes: 'All'
        }).then(function(stats) {
            rc.stats = stats;
        });
    }

    rc.home = () => {
        locationService.home();
    };

    rc.go = function(path) {
        $location.path(path);
    };

    rc.menuClicked = function(e) {
        sidebarMenuOpen = !sidebarMenuOpen;
        $scope.$broadcast('menuClicked');
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
    };

    rc.hideOverflow = function() {
        return sidebarMenuOpen ? 'hide-overflow' : '';
    };

    rc.hideSiteMailingSignUp = function() {
        let url = $location.path();
        if (!url.match(/prefetch/gi)) {
            if (TRPCONFIG.IsMobileDevice) {
                rc.hideSiteMailingListSignUp = url === '/' || !!url.match(TRPCONFIG.Domain.HideSiteMailingSignUpMobile, 'gi');
            } else {
                rc.hideSiteMailingListSignUp = url === '/' || !!url.match(TRPCONFIG.Domain.HideSiteMailingSignUpDesktop, 'gi');
            }
        }
    };

    broker.subscribe('RootController', 'hideNavigationDrawer', function() {
        sidebarMenuOpen = false;
    });

    broker.subscribe('RootController', 'userExtended', function(extendedUser) {
        if (!extendedUser || !extendedUser.data) {
            return;
        }

        const customer = extendedUser.data;

        if (customer.FirstName && customer.LastName) {
            rc.impersonatedUserName = `${customer.FirstName} ${customer.LastName}`;
        }

        if (customer.Contact && customer.Contact.FirstName && customer.Contact.LastName) {
            return rc.impersonatedUserName = `${customer.Contact.FirstName} ${customer.Contact.LastName}`;
        }
    });

    broker.subscribe('RootController', 'userDeimpersonated', function() {
        rc.impersonatedUserName = false;
    });

    rc.brokerPublish = function(key, val) {
        broker.publish(key, val);
    };

    $(window).on('resize', _.debounce(function() {
        /*this doesn't do anything but it appears to trigger a digest on
        windows resize which is what we want.*/
    }, 100));


    broker.subscribe('RootController', 'destinationChanged', _updateShowCaseStyle);

    function _updateShowCaseStyle() {
        currentDestination.getCurrentDestination().then(function(dest) {
            let url = imageService.getLandingPageImage(dest);
            rc.showcaseStyle = url ? { 'background-image': `url(${url})` } : undefined;    //prevent bindonce from giving up until we have a value

            const hero = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.MobileDestinationOverlay.ImageSrc');
            rc.promoOverlayStyle = hero && dest ? { 'background-image': `url(${hero})` } : { display: 'none' };

            rc.destination = dest;

            const mobileBannerImage = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.MobileBanner.ImageSrc');

            rc.sale = mobileBannerImage && !rc.destination;
            url = url || mobileBannerImage;
            if (url) {
                rc.heroStyle = { 'background-image': `url(${url})` };
            }
            rc.heroStyleSkip = rc.destination == null ? { 'background-image': 'url(build/img/beach-background.png)' } : rc.heroStyle;
        });
    }

    _updateShowCaseStyle();

    rc.backgroundStyle = function() {
        const loadingScreenBackground = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.ResponsiveInterstitialBackground.ImageSrc');
        //if get image from cms enabled then return null
        if (TRPCONFIG.Domain.CMSInterstitialImagesEnabled) {
            return null;
        }
        return loadingScreenBackground ? { 'background-image': `url(${loadingScreenBackground})` } : { 'background-image': 'url(build/img/beach-background.png)' };
    };

    rc.bannerStyle = function() {
        const loadingScreenBanner = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.ResponsiveInterstitialBanner.ImageSrc');
        return loadingScreenBanner ? { 'background-image': `url(${loadingScreenBanner})` } : '';
    };

    $rootScope.lockScreen = function(scope, data) {
        scope.$emit('block', data || {});
    };

    $rootScope.unlockScreen = function(sc) {
        broker.publish('unblock');
        sc.$emit('unblock');
    };

    $rootScope.$on('$routeChangeStart', function(_, next) {
        rc.showStrapLine = _getStrapLine($location.$$path, next.strapLine);
    });

    /*
     * Return logic only for all page except "/pages/terms"
     * @param path
     * @param strapLine
     * @returns {boolean}
     * @private
     */
    function _getStrapLine(path, strapLine) {
        return path === '/pages/terms' ? null : !!strapLine;
    }

    $scope.$on('$destroy', () => {
        broker.unsubscribe('RootController');
    });

    rc.signout = function() {
        agentModeService.signout().then(function() {
            window.location.href = $location.search().Dest || '/';
        });
    };

}
})();
